




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { convertToCurrencyFormat } from '@core/tools/Formatter'

@Component({
  components: {
  }
})
export default class TheCurrentPlansSummary extends Vue {
  @Prop() readonly columns!: { attrName: string; abbre: string }[]
  @Prop() readonly summary!: { c1: {}; c2: {}; others: {} }
  @Prop() readonly currencySetting!: string

  get isClient2Included () {
    return Object.keys(this.summary.c2).length
  }

  convertToCurrencyFormat (value) {
    return convertToCurrencyFormat(value, this.currencySetting)
  }
}
